import { SET_TAB_DETAIL, SET_FILTER_DETAIL } from './types'

const setTabDetails = payload => ({ type: SET_TAB_DETAIL, payload })
const setFilterDetails = payload => ({ type: SET_FILTER_DETAIL, payload })

export { setTabDetails, setFilterDetails }
